import { api, API_PREFIX, withFallback } from './client'
import type { SettingRegistryEntry, SettingsByGroup, SettingsUpdate, SettingValue } from '../../types/api'

/** GET /settings/registry (new) */
export async function getSettingsRegistry(): Promise<SettingRegistryEntry[]> {
  return withFallback(async () => {
    const res = await api.get<SettingRegistryEntry[]>(`${API_PREFIX}/settings/registry`)
    return Array.isArray(res.data) ? res.data : []
  }, [])
}

/** GET /settings?group_id= → { [ui_group]: [{key, value, source}] } (new) */
export async function getSettings(groupId?: string | null): Promise<SettingsByGroup> {
  return withFallback(async () => {
    const res = await api.get<SettingsByGroup>(`${API_PREFIX}/settings`, { params: groupId ? { group_id: groupId } : undefined })
    return res.data ?? {}
  }, {})
}

/** PUT /settings body { group_id?, values } (new) */
export async function updateSettings(body: SettingsUpdate): Promise<SettingValue[] | void> {
  const res = await api.put(`${API_PREFIX}/settings`, body)
  return res.data
}

/** Flatten the grouped response into a key → SettingValue map. */
export function flattenSettings(grouped: SettingsByGroup): Record<string, SettingValue> {
  const out: Record<string, SettingValue> = {}
  for (const list of Object.values(grouped)) for (const v of list ?? []) out[v.key] = v
  return out
}
